// Archivo para el botón de eliminar
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import Icon from '@mui/icons-material/Delete'
import GenericModal from '../modal/GenericModal'
import { useCrud } from '../../context/CrudContext'
import useAuth from '../../hooks/useAuth'

const DeleteButton = ({ entityType, disabled, itemId }) => {
  const { t } = useTranslation()
  const [showConfirm, setShowConfirm] = useState(false)
  const { handleCrudOperation, loadingStates } = useCrud()
  const { user } = useAuth()

  const handleDelete = async () => {
    try {
      await handleCrudOperation('delete', entityType, {
        id: itemId,
        headers: { 'X-User-Role': user.role },
      })
      setShowConfirm(false)
    } catch (error) {
      console.error('Delete error:', error)
      // Aquí deberías disparar una notificación de error
    }
  }

  const buttonText = t(
    `buttons.delete${entityType.charAt(0).toUpperCase() + entityType.slice(1)}`
  )
  const isLoading = loadingStates.delete[itemId]

  return (
    <>
      <button
        className={`button delete-button ${entityType}-delete-button`}
        onClick={() => setShowConfirm(true)}
        disabled={disabled || isLoading}
        aria-label={buttonText}
      >
        <Icon fontSize="small" />
        <span>{!isLoading ? buttonText : t('buttons.deleting')}</span>
        {isLoading && <span className="button-spinner" />}
      </button>

      <GenericModal
        open={showConfirm}
        onClose={() => setShowConfirm(false)}
        title={t('modals.confirmDeleteTitle')}
        actions={[
          {
            text: t('buttons.cancel'),
            handler: () => setShowConfirm(false),
          },
          {
            text: isLoading
              ? t('buttons.deleting')
              : t('buttons.confirmDelete'),
            handler: handleDelete,
            danger: true,
            disabled: isLoading,
          },
        ]}
      >
        <p>{t('modals.confirmDeleteContent', { entityType })}</p>
      </GenericModal>
    </>
  )
}

DeleteButton.propTypes = {
  entityType: PropTypes.oneOf(['user', 'client', 'product', 'activity', 'task'])
    .isRequired,
  disabled: PropTypes.bool,
  itemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
}

DeleteButton.defaultProps = {
  disabled: false,
}

export default DeleteButton
